import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

// Vite's BASE_URL points at static asset path (e.g. /static/bzuco_guard/mobile-next/);
// the router base must match the URL the app is actually served from on Django (/mobile-next/).
const APP_BASE = import.meta.env.VITE_APP_BASE || '/'

const router = createRouter({
    history: createWebHistory(APP_BASE),
    routes: [
        { path: '/', name: 'home', component: HomeView },
        { path: '/login/', name: 'login', component: () => import('@/views/LoginView.vue') },
        { path: '/events/', name: 'events', component: () => import('@/views/EventsView.vue') },
        { path: '/zones/', name: 'zones', component: () => import('@/views/ZonesView.vue') },
        { path: '/ticketsets/', name: 'ticketsets', component: () => import('@/views/TicketsetsView.vue') },
        {
            path: '/scanner/',
            name: 'scanner',
            component: () => import('@/views/ScannerView.vue'),
            props: { test: false }
        },
        {
            path: '/test-scanner/',
            name: 'test-scanner',
            component: () => import('@/views/ScannerView.vue'),
            props: { test: true }
        },
        {
            path: '/config-scanner/',
            name: 'config-scanner',
            component: () => import('@/views/ConfigScannerView.vue')
        },
        { path: '/settings/', name: 'settings', component: () => import('@/views/SettingsView.vue') },
        { path: '/statistics/', name: 'statistics', component: () => import('@/views/StatisticsView.vue') }
    ]
})

export default router
